<script>
import Multiselect from "vue-multiselect";

export default {
  name: "FormSelector",
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: false,
      default: () => "",
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    fetchOptions: {
      type: Function,
      required: false,
    },
    drfProv_ider: {
      type: Boolean,
      required: false,
      default: true,
    },
    opts: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      loadingOptions: false,
      optionsMounted: true,
      optionsCache: [],
    };
  },
  computed: {
    // ...authComputed,
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted: function () {
    let context = this;
    if (this.drfProv_ider) {
      context.populateOptions();
    } else {
      this.options = this.opts;
    }
  },

  methods: {
    populateOptions(searchQuery) {
      let context = this;
      context.loadingOptions = true;
      let reqParams = context.$select_params_standard(searchQuery);
      const promise = context.fetchOptions(reqParams);
      return promise
        .then((data) => {
          let listOptions = [];
          data.results.forEach((opt) => {
            listOptions.push({
              _id: opt._id,
              name: opt.name || opt._id,
            });
          });
          context.options = listOptions;
          context.loadingOptions = false;
          context.optionsMounted = true;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.loadingOptions = false;
          context.optionsMounted = true;
        });
    },

    asyncFindOptions: _.debounce(function (searchQuery) {
      this.populateOptions(searchQuery);
    }, 600),

    labelOfOption(opt) {
      let context = this;
      let optionFound = context.options.find((x) => x._id === opt);
      if (!optionFound) {
        let cacheFound = context.optionsCache.find((x) => x._id === opt);
        return cacheFound
          ? cacheFound.name
          : context.optionsMounted
          ? `${"label_not_found"}: ${opt}`
          : "";
      } else {
        if (context.inputVal === opt) {
          if (!context.optionsCache.find((x) => x._id === opt)) {
            context.optionsCache.push(optionFound);
          }
        }
        return optionFound.name;
      }
    },

    customLabel(opt) {
      let context = this;
      let optionFound = context.options.find((x) => x._id === opt);
      if (!optionFound) {
        let cacheFound = context.optionsCache.find((x) => x._id === opt);
        return cacheFound
          ? cacheFound.name
          : context.optionsMounted
          ? `${"label_not_found"}: ${opt}`
          : "";
      } else {
        if (context.inputVal === opt) {
          if (!context.optionsCache.find((x) => x._id === opt)) {
            context.optionsCache.push(optionFound);
          }
        }
        return optionFound.name;
      }
    },
  },
};
</script>

<template>
  <b-container class="pr-1">
    <b-form-group class="mb-0">
      <b-row>
        <b-col :md="12">
          <Multiselect
            v-if="drfProv_ider"
            v-model="inputVal"
            :multiple="multiple"
            :options="options.map((x) => x._id)"
            :custom-label="(opt) => labelOfOption(opt)"
            :loading="loadingOptions"
            :internal-search="false"
            :select-label="$t('multiselect.select')"
            :selected-label="$t('multiselect.selected')"
            :deselect-label="$t('multiselect.deselect')"
            :placeholder="label"
            @search-change="asyncFindOptions"
          >
          </Multiselect>
          <Multiselect
            v-else
            v-model="inputVal"
            :multiple="multiple"
            :options="options.map((x) => x.value)"
            :custom-label="(opt) => options.find((x) => x.value === opt).name"
            :internal-search="false"
            :select-label="$t('multiselect.select')"
            :selected-label="$t('multiselect.selected')"
            :deselect-label="$t('multiselect.deselect')"
            :placeholder="label"
          >
          </Multiselect>
        </b-col>
      </b-row>
    </b-form-group>
  </b-container>
</template>
<style lang="scss">
// .multiselect__tags {
// 	min-height: 38px;
// 	display: block;
// 	max-height: 30px;
// 	padding: 6px 40px 0 8px;
// 	border-radius: 5px;
// 	border: 1px sol_id #0570a7;
// 	background: #fff;
// 	font-size: 14px
// }
</style>
